import React from 'react';

const WaffleGrid = ({ stablecoinPercentage, animationKey }) => {
  const totalSquares = 100;
  const filledSquares = Math.round(stablecoinPercentage * 100);

  const getSquareColor = (index) => {
    if (index < filledSquares) {
      return 'bg-primary';
    }
    return 'bg-muted';
  };

  return (
    <div 
      key={animationKey}
      className="grid grid-cols-10 gap-1 md:gap-2 w-full max-w-2xl mx-auto p-4 md:p-6 lg:p-8 bg-card rounded-lg shadow-sm"
      style={{ aspectRatio: '1/1' }}
    >
      {Array.from({ length: totalSquares })?.map((_, index) => (
        <div
          key={index}
          className={`${getSquareColor(index)} rounded transition-all duration-500 ease-in-out`}
          style={{
            animationDelay: `${index * 5}ms`,
            animation: 'fadeIn 0.5s ease-in-out'
          }}
        />
      ))}
      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: scale(0.8);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
      `}</style>
    </div>
  );
};

export default WaffleGrid;